export default {
  0: {
    disabled: true,
    options: [{ value: 0, label: 'システム管理者' }],
    rules: {},
  },
  1: {
    disabled: true,
    options: [{ value: 1, label: '管理者' }],
    rules: {},
  },
  2: {
    disabled: false,
    options: [
      { value: 2, label: 'サブ管理者' },
      { value: 3, label: '閲覧者' },
      { value: 4, label: '広告配信者' },
    ],
    rules: { required: true },
  },
  3: {
    disabled: false,
    options: [
      { value: 2, label: 'サブ管理者' },
      { value: 3, label: '閲覧者' },
      { value: 4, label: '広告配信者' },
    ],
    rules: { required: true },
  },
  4: {
    disabled: false,
    options: [
      { value: 2, label: 'サブ管理者' },
      { value: 3, label: '閲覧者' },
      { value: 4, label: '広告配信者' },
    ],
    rules: { required: true },
  },
}
